import { Link } from 'react-router-dom';
import { styled } from '../../../configs/stitches.config';

export const Logo = styled('img', {
  height: '65%',
  width: '65%',
});

export const LogoWrapper = styled(Link, {
  height: '80%',
  marginLeft: '$spacingLg',
  width: '90%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
